// The Infinite Options price block uses the shop's "£1.00 GBP" format; show "£1.00" like the rest of the theme.
document.addEventListener('DOMContentLoaded', () => {
  const stripCurrencyCode = (price) => {
    const text = price.textContent;
    if (/ GBP\s*$/.test(text)) price.textContent = text.replace(/\s*GBP\s*$/, '');
  };

  document.querySelectorAll('.infiniteoptions-price').forEach((block) => {
    const clean = () => block.querySelectorAll('.price-item').forEach(stripCurrencyCode);
    clean();
    new MutationObserver(clean).observe(block, { childList: true, subtree: true, characterData: true });
  });
});
